// Icons
import { FaCircle } from 'react-icons/fa';
import { RiAlertFill } from 'react-icons/ri';
import { BiDotsHorizontal } from 'react-icons/bi';

// Component imports
import SelectDataButton from '../../date-selector';

// Asset imports
import waterFlowIcon from '../../../../assets/icons/water-flow-icon.png';

export function Hidrometer({
	sensor,
	hidrometerValue,
	accPeriod1,
	setAccPeriod1,
	accPeriod2,
	setAccPeriod2,
	accumulatedValue,
	STATUS_COLORS,
	statusColor,
}) {
	return (
		<div>
			{/* Seção do Hidrômetro */}
			<div className="last-data-container">
				<div className="last-data-content-container">
					<div className="container-hidrometro">
						<div className="circle-hidrometro">
							<div className="inner-circle-hidrometro">
								<p>Hidrômetro</p>
								<p className="value-hidrometro">
									{!isNaN(hidrometerValue) ? `${hidrometerValue.toFixed(1)} m³` : '-- m³'}
								</p>
								{sensor.alerta_superior > 0 &&
									(statusColor === STATUS_COLORS.ONLINE_NORMAL ? (
										<FaCircle
											style={{
												color: 'green',
												marginLeft: '8px',
												fontSize: '36px',
											}}
										/>
									) : statusColor === STATUS_COLORS.ONLINE_ALERT ? (
										<RiAlertFill
											style={{
												color: 'red',
												marginLeft: '8px',
												fontSize: '36px',
											}}
										/>
									) : (
										<FaCircle
											style={{
												color: 'gray',
												marginLeft: '8px',
												fontSize: '36px',
											}}
										/>
									))}
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Seção de Valor Acumulado */}
			<div>
				<div className="panel-items">
					<BiDotsHorizontal />
					<span className="panel-items-title">Valor Acumulado</span>
				</div>
				<SelectDataButton
					periodo1={accPeriod1}
					setPeriodo1={setAccPeriod1}
					periodo2={accPeriod2}
					setPeriodo2={setAccPeriod2}
					hourlyData={true}
				/>
				<div className="last-data-container">
					<div className="last-data-content-container">
						<img
							src={waterFlowIcon}
							height={'40px'}
							width={'40px'}
							alt="water-flux-icon"
							style={{ marginRight: '5px' }}
						/>
						<p className="last-value-text">
							{!isNaN(accumulatedValue) ? `${accumulatedValue.toFixed(2)} m³` : '-- m³'}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
